import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Select, MenuItem, InputLabel, FormControl, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { apiRequest } from '../../../utils/fetch';
import { UserRoleInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const initialRole: Partial<UserRoleInterface> = {
  roleName: '',
  description: '',
  active: true,
};

const UserRolesAdminAddUserRolePage: React.FC = () => {
  const [role, setRole] = useState<Partial<UserRoleInterface>>(initialRole);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (field: keyof UserRoleInterface, value: any) => {
    setRole(r => ({ ...r, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    try {
      const result = await apiRequest<GenericResponseInterface<UserRoleInterface>>('/userRoles/insert', 'POST', role);
      if (result.status) {
        setSuccess(result.message || 'User role created successfully!');
        setDialogOpen(true);
        setRole(initialRole);
      } else {
        setError(result.message || 'Failed to create user role');
        setDialogOpen(true);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create user role');
      setDialogOpen(true);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add New User Role</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Role Name"
          value={role.roleName ?? ''}
          onChange={e => handleChange('roleName', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Description"
          value={role.description ?? ''}
          onChange={e => handleChange('description', e.target.value)}
          fullWidth
          margin="dense"
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="active-label">Active</InputLabel>
          <Select
            labelId="active-label"
            value={role.active !== undefined ? (role.active ? 'yes' : 'no') : 'yes'}
            label="Active"
            onChange={e => handleChange('active', e.target.value === 'yes')}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary">
            Create Role
          </Button>
        </Box>
      </form>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{success ? 'Success' : 'Error'}</DialogTitle>
        <DialogContent>
          <Typography>{success || error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default UserRolesAdminAddUserRolePage;